export default "__VITE_ASSET__DTQKzKMI__"